module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dy-item-wrap', {
    attrs: {
      "item": _vm.item
    }
  }, [_c('yjp-input-number-range', _vm._g(_vm._b({
    attrs: {
      "precision": _vm.item.precision || 0
    }
  }, 'yjp-input-number-range', _vm.$attrs, false), _vm.$listeners))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5875734c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DynamicForm/widgets/NumberRangeWidget.vue
// module id = 720
// module chunks = 20